// Web mock for react-native-tracking-transparency
export const TrackingStatus = {
  unavailable: 'unavailable',
  denied: 'denied',
  authorized: 'authorized',
  restricted: 'restricted',
  notDetermined: 'not-determined',
} as const;

export async function getTrackingStatus(): Promise<string> {
  return 'authorized';
}

export async function requestTrackingPermission(): Promise<string> {
  return 'authorized';
}

export default {
  getTrackingStatus,
  requestTrackingPermission,
  TrackingStatus,
};
